import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import {
  ClientAddressModel,
  ClientPropertyBalanceListModel,
  ICPLClientPortalAccountsClient,
  PLClientTransactionModel,
  PLInvoiceChargeModel,
} from "./api/cplapi/CPLAPI";

export interface IClientPortalAccountsService {
  downloadClientInvoicePDF(plClientTransactionFileID: string): Promise<File>;
  getOverallOutstandingBalance(): Promise<number>;
  getBalancesForAllProperties(): Promise<ClientPropertyBalanceListModel>;
  getAllTransactionsForClient(clientID): Promise<PLClientTransactionModel>;
  getAllInvoicesForTransaction(transactionID: string): Promise<PLInvoiceChargeModel>;
  downloadChargeFilePDF(chargeFileID: string): Promise<File>;
  getClientBillingAddress(): Promise<ClientAddressModel>;
}

@injectable()
export class ClientPortalAccountsService implements IClientPortalAccountsService {
  @inject(SERVICE_TYPES.CPLClientPortalAccountsClient)
  cplClientPortalAccountsClient!: ICPLClientPortalAccountsClient;

  async getOverallOutstandingBalance(): Promise<number> {
    return await this.cplClientPortalAccountsClient.getOverallOutstandingBalance();
  }

  async getBalancesForAllProperties(): Promise<ClientPropertyBalanceListModel> {
    return await this.cplClientPortalAccountsClient.getBalancesForAllProperties();
  }

  async getAllTransactionsForClient(clientID: string): Promise<PLClientTransactionModel> {
    return await this.cplClientPortalAccountsClient.getAllTransactionsForClient(clientID);
  }

  async getAllInvoicesForTransaction(transactionID: string): Promise<PLInvoiceChargeModel> {
    return await this.cplClientPortalAccountsClient.getAllInvoicesForTransaction(transactionID);
  }

  async downloadChargeFilePDF(chargeFileID: string): Promise<File> {
    const fileResponse = await this.cplClientPortalAccountsClient.downloadChargeFilePDF(chargeFileID);
    return new File([fileResponse.data], fileResponse.fileName!);
  }

  async downloadClientInvoicePDF(plClientTransactionFileID: string): Promise<File> {
    const fileResponse = await this.cplClientPortalAccountsClient.downloadClientInvoicePDF(plClientTransactionFileID);
    return new File([fileResponse.data], fileResponse.fileName!);
  }

  async getClientBillingAddress(): Promise<ClientAddressModel> {
    return await this.cplClientPortalAccountsClient.getClientBillingAddress();
  }
}
